import * as React from 'react';
import { SingleKeyValueComponent, ComplexValue } from '../common/types';
import { getOptionsOrDefault } from '../common/code-table/get-options-or-default';
import { SelectSingleRadioButton } from './select-single-radio-button/select-single-radio-button';
import { InputControlContext } from '../common/input-control-context/input-control-context';
import styles from './select-single-short-list.scss';
import get from 'lodash/get';
import { VisibilitySensor } from '../common';
import { ElementLoader } from '../common/element-loader/element-loader';

interface SelectSingleShortListProps extends SingleKeyValueComponent<number> {
  textOptionsNotFound?: string;
  textOptionsLoadError?: string;
  isVertical?: boolean;
}

export class SelectSingleShortList extends React.PureComponent<SelectSingleShortListProps, any> {
  private loadOptions = () => {
    const {onLoadOptions, options} = this.props;
    const needsOptions = !options || !options.length;
    if (needsOptions && onLoadOptions) {
      onLoadOptions(undefined);
    }
  }

  private renderOptions() {
    return getOptionsOrDefault(this.props.valueItem, this.props.options)
      .map((item, index) => item.value !== 0 && this.renderItem(index, item, this.props.valueItem));
  }

  private renderItem = (index: number, item: ComplexValue<number>, selectedOption?: ComplexValue<number>) => {
    const path = JSON.stringify(get(this.props, 'resolveContext.path'));

    return <div className="col col-auto" key={index}>
      <SelectSingleRadioButton
        componentId={`${this.props.componentId}-${path}-${item.value}-radio`}
        onChange={this.props.onChange}
        readOnly={this.props.readOnly}
        isSelected={selectedOption ? item.value === selectedOption.value : false}
        option={item} />
    </div>;
  }

  public render() {
    const {options, fetching, loadOptionsError, textOptionsNotFound, textOptionsLoadError, isVertical} = this.props;
    if(!options || !options.length){
      return (
        <InputControlContext {...this.props as any}>
          <VisibilitySensor onShow={this.loadOptions}>
            {fetching ?
              <ElementLoader/> :
              (loadOptionsError ?
                textOptionsLoadError :
                textOptionsNotFound
              )
            }
          </VisibilitySensor>
        </InputControlContext>
      );
    }
    return (
      <InputControlContext {...this.props as any}>
        <div className={styles.selectShortList}>
          <div className={`row ${isVertical ? styles.vertical : ''}`}>
            {this.renderOptions()}
          </div>
        </div>
      </InputControlContext>
    );
  }
}
